import { R4 } from '@ahryman40k/ts-fhir-types';
import { DependentRelation } from '../contexts/a2i-data-provider';

export interface Consent extends R4.IConsent {}

export const parseConsentsBundle = (bundle: R4.IBundle): Array<Consent> => {
  const consents = bundle.entry
    ?.filter((e) => e.resource!.resourceType === 'Consent')
    .map((e) => parseConsent(e.resource as R4.IConsent));

  return consents ?? [];
};

export const getDependentRelationsFromBundle = (
  bundle: R4.IBundle,
  mainUser: string
): Array<DependentRelation> => {
  const consents = parseConsentsBundle(bundle);

  return (
    consents
      .map((consent) => {
        const code = consent?.provision?.actor
          ?.find((actor) => actor.reference.reference === mainUser)
          ?.role.coding?.find(
            (coding) => coding.system === 'http://terminology.hl7.org/CodeSystem/v3-RoleClass'
          )?.code;

        return {
          id: consent.patient?.reference
            ?.substring(consent.patient?.reference.indexOf('/') + 1)
            .trim(),
          code: code
        };
      })
      // Force TS to take this as an array of strings since it does not identify
      // that .filter will remove all undefined ids
      .filter((id) => !!id.id) as Array<DependentRelation>
  );
};

export const parseConsent = (consent: R4.IConsent): Consent => {
  return {
    ...consent
  };
};
